import React from 'react';
import { Search, Loader2, RefreshCw, ShieldAlert } from 'lucide-react';

const STATUS_OPTIONS = ['', 'analyzed', 'escalated', 'pending', 'skipped_short', 'no_transcript'];

export const CallsToolbar = ({
  search, onSearch,
  statusFilter, onStatusFilter,
  grading, onRegradeAll,
  governanceOnly, onToggleGovernance, governanceCount = 0,
}) => (
  <div className="px-4 py-3 border-b border-white/5 flex flex-col sm:flex-row gap-3">
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30 w-4 h-4" />
      <input
        type="text"
        placeholder="Search agent, number, call ID..."
        value={search}
        onChange={e => onSearch(e.target.value)}
        className="w-full pl-9 pr-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-sm text-white placeholder-white/30 focus:outline-none focus:border-teal-500/50"
        data-testid="calls-search-input"
      />
    </div>
    <div className="flex items-center gap-2 flex-wrap">
      {STATUS_OPTIONS.map(s => (
        <button
          key={s || 'all'}
          onClick={() => onStatusFilter(s)}
          className={`text-xs px-2.5 py-1 rounded-lg transition-colors ${
            statusFilter === s ? 'bg-teal-500 text-white' : 'bg-white/5 text-white/40 hover:bg-white/10 hover:text-white/70'
          }`}
          data-testid={`calls-filter-${s || 'all'}`}
        >
          {s || 'All'}
        </button>
      ))}
      {onToggleGovernance && (
        <button
          onClick={() => onToggleGovernance(!governanceOnly)}
          title={governanceOnly
            ? 'Showing only calls flagged for governance / compliance — click to clear'
            : 'Show only calls with a governance breach (compliance / trust escalations)'}
          className={`flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-lg transition-colors border ${
            governanceOnly
              ? 'bg-red-600/25 text-red-200 border-red-500/50'
              : 'bg-white/5 text-white/40 border-transparent hover:bg-red-600/10 hover:text-red-300'
          }`}
          data-testid="governance-only-toggle"
        >
          <ShieldAlert className="w-3 h-3" />
          Governance
          {governanceCount > 0 && (
            <span className="ml-0.5 text-[10px] font-semibold px-1 rounded bg-red-500/40 text-white">
              {governanceCount}
            </span>
          )}
        </button>
      )}
      <button
        onClick={onRegradeAll}
        disabled={grading}
        title="Re-grade all"
        className="flex items-center gap-1.5 text-xs px-2.5 py-1 bg-violet-500/20 hover:bg-violet-500/30 text-violet-300 rounded-lg transition-colors disabled:opacity-50"
        data-testid="regrade-all-btn"
      >
        {grading ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />}
        Re-grade
      </button>
    </div>
  </div>
);
